<template>
    <AlertMessage
        v-if="messagekey != ''"
        type="danger"
        :show-icon="true"
        ><span v-html="$ti(messagekey, messageparams, true)"></span
    ></AlertMessage>
</template>
<script lang="ts" setup>
import { AlertMessage } from '@/components';
import { $ti } from '@/locize';
import type { ITranslationKey } from '@/objects/TranslationKey';
import { computed } from 'vue';

const props = defineProps<{
    /**
     * The message to display.
     */
    message: ITranslationKey | string | null;
}>();

const messagekey = computed(() => {
    if (props.message === null) {
        return '';
    }

    if (typeof props.message === 'string') {
        return props.message;
    } else {
        return props.message.key ?? '';
    }
});

const messageparams = computed(() => {
    if (props.message === null) {
        return {};
    }

    if (typeof props.message === 'string') {
        return {};
    } else {
        return props.message.params ?? {};
    }
});
</script>
